import { FC } from 'react';

import { Formik } from 'formik';
import { isStrictEqual } from 'remeda';
import { FormBodyContainer } from 'wbs-components-lib';

import { VipTaskItemValidateFormProps } from './types';
import { vipTaskItemValidationSchema } from './validationSchema';

import { FileSelector } from 'v2/components/fileSystem/fileSelector/FileSelector';

export const VipTaskItemValidateForm: FC<VipTaskItemValidateFormProps> = ({
  initialValues,
  onSubmit,
  isSubmitting = false,
}) => {
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={vipTaskItemValidationSchema}
      enableReinitialize
    >
      {({ submitForm, values, setFieldValue }) => {
        const { documentId: documentIdValue } = values;

        const onCasinoSubmit = async () => {
          await submitForm();
        };

        const isSubmitButtonDisabled = isStrictEqual(values, initialValues);

        return (
          <FormBodyContainer
            isSubmitting={isSubmitting}
            onSubmit={onCasinoSubmit}
            submitButtonCaption="Validate"
            isSubmitButtonDisabled={isSubmitButtonDisabled}
          >
            <FileSelector
              label="Document"
              value={documentIdValue ?? ''}
              onSelect={(value) => setFieldValue('documentId', value)}
              required
            />
          </FormBodyContainer>
        );
      }}
    </Formik>
  );
};
